import React,{useState} from 'react'
import { Box, Typography, Snackbar, Alert,LinearProgress } from '@mui/material'
import SignInMessage from './SignInMessage'
import CustomTextField from '../CustomTextField'
import CustomeButton from '../CustomeButton'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import LockIcon from '@mui/icons-material/Lock'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {changePassword} from '../../slices/userSlice'
import { useDispatch } from 'react-redux'
import Confirmation from '../../components/Confirmation'

const ChangePasswordSection = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [snackbarSeverity, setSnackbarSeverity] = useState('success')
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false)
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false)

  const formik = useFormik({
    initialValues: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required('Old password is required'),
      newPassword: Yup.string().required('New password is required').notOneOf([Yup.ref('oldPassword'), null], 'Passwords must be different'),
      confirmPassword: Yup.string()
        .required('Confirm password is required')
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
    }),
    onSubmit: (values) => {
      setIsConfirmDialogOpen(true)
      
      //navigate('/')
    },
  })

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false)
  }
  const handleConfirmWindow = () => {
    dispatch(changePassword(formik.values))
    .then((result) => {
      setSnackbarMessage(result.payload.data.status);
      if(result.payload.statusCode === 200){
        setSnackbarSeverity('success');
        setIsLogoutDialogOpen(true);
      } else{
        setSnackbarSeverity('error');
      } 
    })
    .catch(() => setSnackbarMessage('Failed to update password', 'error'))
    setSnackbarOpen(true)
    setIsConfirmDialogOpen(false)
    
  }
  const handleLogoutCOnfirmation=()=>{
    setIsLogoutDialogOpen(false);
    navigate('/')
  }
  return (
    <Box
      component='form'
      onSubmit={formik.handleSubmit}
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Typography variant='h5' sx={{ fontWeight: 'bold', marginBottom: 4 }}>
        Change <span style={{ color: '#F6764E' }}>Password</span>
      </Typography>

      <SignInMessage
        text='Please enter old password and new password to change password'
        color='black'
        sx={{ marginBottom: '8px' }}
      />
      

      <CustomTextField
        icon={MailOutlineIcon}
        placeholder='Old Password*'
        type='password'
        name='oldPassword'
        value={formik.values.oldPassword}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.oldPassword && Boolean(formik.errors.oldPassword)}
        helperText={formik.touched.oldPassword && formik.errors.oldPassword}
        sx={{
          width: '40%',
          marginBottom: 2,
          '& .MuiFilledInput-root': {
            padding: '4px 8px',
            backgroundColor: 'white',
          },
        }}
      />

      <CustomTextField
        icon={MailOutlineIcon}
        placeholder='New Password*'
        type='password'
        name='newPassword'
        value={formik.values.newPassword}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
        helperText={formik.touched.newPassword && formik.errors.newPassword}
        sx={{
          width: '40%',
          marginBottom: 2,
          '& .MuiFilledInput-root': {
            padding: '4px 8px',
            backgroundColor: 'white',
          },
        }}
      />

      <CustomTextField
        icon={LockIcon}
        placeholder='Confirm Password*'
        type='password'
        name='confirmPassword'
        value={formik.values.confirmPassword}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.confirmPassword &&
          Boolean(formik.errors.confirmPassword)
        }
        helperText={
          formik.touched.confirmPassword && formik.errors.confirmPassword
        }
        sx={{
          width: '40%',
          marginBottom: 2,
          '& .MuiFilledInput-root': {
            padding: '4px 8px',
            backgroundColor: 'white',
          },
        }}
      />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
          width: '30%',
          maxWidth: '500px',
          margin: '0 auto',
        }}>
        <CustomeButton
          type='submit'
          text='Submit'
          sx={{
            flex: 1,
            marginBottom: 0,
          }}
          disabled = {
            !formik.values.oldPassword ||
            !formik.values.newPassword ||
            !formik.values.confirmPassword
          }
        />
        <CustomeButton
          text='Cancel'
          sx={{
            flex: 1,
            marginBottom: 0,
          }}
          onClick={() => navigate('/admin')}
        />
      </Box>
      {/* snackbar  */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}>
          {snackbarMessage}
          <LinearProgress
            variant='determinate'
            value={100}
            sx={{
              animation: 'progressBar 4s linear forwards',
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              boxSizing: 'border-box',
              transformOrigin: 'right',
            }}
          />
        </Alert>
      </Snackbar>

      <Confirmation
        open={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirmWindow}
        message={'Are you sure? Do you want to Change Password?'}
      />
      <Confirmation
        open={isLogoutDialogOpen}
        onClose={() => setIsLogoutDialogOpen(false)}
        onConfirm={handleLogoutCOnfirmation}
        message={'You need to logout to get changes effected.'}
      />
    </Box>
  )
}

export default ChangePasswordSection
